// extracted by mini-css-extract-plugin
module.exports = {"container":"checkbox_container__2ZkG_","label":"checkbox_label__27w4O","checkmark":"checkbox_checkmark__1-juk"};